//标签类型
const LabelType = {
  PriceLabel: 1, //价格标签1
  TitleLabel: 2, //标题小图标2
  ServiceLabel: 3 //服务标签3
}

//轮播展示位置
const RotationPlotShowType = {
  Top: 1, //详情顶部
  Details: 2, //详情
}

//满减类型
const ReducationType = {
  Money: 1, //金额'
  Amount: 2, //数量
}

//券包给予类型
const PackageGiftType = {
  Receive: 1, //领取
  Purchase: 2, //购买
  Gift: 3 //赠送
}

const CollectType = {
  Goods: 1, //商品
  Brand: 2, //品牌
  Subscribe: 3, //订阅 
}

export {
  LabelType,
  RotationPlotShowType,
  ReducationType,
  PackageGiftType,
  CollectType
}